import React, { useState, useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row, Table, Dropdown, Modal, Tab, Tabs, Stack, Button, Form, Accordion } from 'react-bootstrap';
import { faCircleXmark, faGear, faCog, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';

import Modal_user from "../../../../assets/images/Modal_user.png";
import Docmnt from '../../../../assets/images/google-docs.png';

import MessageBox from '../../../../Components/common/MessageBox';
import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { useUserCheckQuery } from '../../../../redux/services/Auth.js';

const NewTask = ({ onReload, onClose, OData }) => {

    const notification = [
        { label: "Due = in 3 days, Rem = the day before", value: 1, dueOffset: 3, remOffset: 1 },
        { label: "Due = in a week, Rem = two days before", value: 2, dueOffset: 7, remOffset: 2 },
        { label: "Due = two weeks, Rem = 3 days before", value: 3, dueOffset: 14, remOffset: 3 },
        { label: "Due = one month, Rem = a week before", value: 4, dueOffset: 30, remOffset: 7 },
        { label: "Due = two months, Rem = a week before", value: 5, dueOffset: 60, remOffset: 7 },
        { label: "Due = 3 months, Rem = a week before", value: 6, dueOffset: 90, remOffset: 7 },
        { label: "Custom Values (Template/Selected)", value: 7, dueOffset: 90, remOffset: 7 }
        // { label: "Every day after due date", value: "eveyDay" },
        // { label: "Every 3 days after due date", value: "3days" },
        // { label: "Every week after due date", value: "week" },
        // { label: "Every 30 days", value: "30days" },
    ];
    const userId = localStorage.getItem('UserID');
    const [departmentList, setDepartmentList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [awbList, setAwbList] = useState([]);
    const [docList, setDocList] = useState([]);

    const fileInputRef = useRef(null);
    const imageUploadRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);
    const [imageOptions, setImageOptions] = useState([]);
    const [files, setFiles] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState([]);
    // const [isTopDel, setIsTopDel] = useState(false);

    const isMounted = useRef(false);
    const [disLoading, setDisLoading] = useState(false);
    const [taskModal, setTaskModal] = useState(true);
    const [templateData, setTemplateData] = useState([]);

    const initialFormData = { assign_to: '61' };
    const [formData, setFormData] = useState(initialFormData);
    const [userDetails, setUserDetails] = useState();

    const { data: myData } = useUserCheckQuery('', {
        // skip: pageDetails.pagesize === 0,
    });
    useEffect(() => {
        if (myData?.response_data) {
            setUserDetails(myData?.response_data);
        }
    }, [myData]);

    const fetchTemplate = async () => {
        try {
            const res = await withRFSToken.get('template/dropdown?tab=task')
                // const res = await withRFSToken.get('template/list?tab=task')
                .then(function (res) {
                    if (res.data.response_code === 200) {
                        const innerData = res.data.response_data;
                        setTemplateData(innerData);
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchdeparrtment = async () => {
        try {
            const res = await withRFSToken.get("/organisation-department/dropdown")
                .then(function (res) {
                    if (res.data.response_code === 200) {
                        const innerData = res.data.response_data;
                        setDepartmentList(innerData)
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchuser = async () => {
        try {
            const res = await withRFSToken.post("uld-setting/get-user-list", { status: 'A' })
                .then(function (res) {
                    const innerData = res.data.Rows;
                    const transformData = innerData ? innerData.map((item) => ({
                        label: item.first_name + ' ' + item.last_name,
                        value: item.user_id
                    })) : []
                    setUserList(transformData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
        setDisLoading(false)
    };
    const fetchImage = async () => {
        try {
            const res = await withRFSToken.get("/file-management/list")
                .then(function (res) {
                    const data = res.data.Rows;
                    const transformData = data?.map(item => ({
                        label: item.file_name,
                        value: item.id,
                        imageUrl: `${item.file_path}`
                    })) || [];
                    setImageOptions(transformData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchAwb = async () => {
        try {
            const res = await withRFSToken.post("service-recovery/all-awb-number")
                .then(function (res) {
                    if (res.data.response_code === 200) {
                        const innerData = res.data.response_data;
                        const transformData = innerData ? innerData.map((item) => ({
                            label: item.master_airway_bill,
                            value: item.taskable_id,
                            taskable_type: item.taskable_type
                        })) : []
                        setAwbList(transformData)
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDoc = async () => {
        try {
            const res = await withRFSToken.get("document/get-all-document-ref")
                .then(function (res) {
                    if (res.data.response_code === 200) {
                        const innerData = res.data.response_data;
                        const transformData = innerData ? innerData.map((item) => ({
                            label: item.master_airway_bill,
                            value: item.taskable_id,
                            taskable_type: item.taskable_type
                        })) : []
                        setDocList(innerData)
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    useEffect(() => {
        if (isMounted.current) return;
        setDisLoading(true)
        fetchTemplate();
        fetchdeparrtment();
        fetchuser();
        fetchImage();
        fetchAwb();
        fetchDoc();
        isMounted.current = true;
    }, []);
    // useEffect(() => {
    //     if (templateData && userList && departmentList) {
    //         setDisLoading(false)
    //     }
    // }, [templateData, userList, departmentList]);

    const CloseModal = () => {
        setTaskModal(false);
        setFormData(initialFormData);
        onClose();
    }

    const handleFieldChange = (field, value) => {
        if (field === 'notifications') {
            const selectedOption = notification.find((n) => n.value === parseInt(value));
            if (selectedOption) {
                const now = new Date();
                const dueDate = new Date(now.getTime() + selectedOption.dueOffset * 24 * 60 * 60 * 1000);
                const reminderDate = new Date(dueDate.getTime() - selectedOption.remOffset * 24 * 60 * 60 * 1000);

                const formatDateTimeLocal = (date) => {
                    const pad = (n) => (n < 10 ? '0' + n : n);
                    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
                    // const year = date.getFullYear();
                    // const month = pad(date.getMonth() + 1);
                    // const day = pad(date.getDate());
                    // const hours = pad(date.getHours());
                    // const minutes = pad(date.getMinutes());
                    // return `${year}-${month}-${day}T${hours}:${minutes}`;
                };

                setFormData((prev) => ({
                    ...prev,
                    notifications: value,
                    due_date: formatDateTimeLocal(dueDate),
                    reminder_date: formatDateTimeLocal(reminderDate)
                }));
            }
        } else if (field === 'due_date') {

            setFormData((prev) => {
                const updated = {
                    ...prev,
                    notifications: 7,
                    due_date: value,
                };
                if (updated.reminder_date) {
                    delete updated.reminder_date;
                }

                return updated;
            });
        } else if (field === 'template_id') {
            setFormData((prev) => ({
                ...prev,
                [field]: value.value,
                title: value.label,
                notifications: value.overdue_notif,
                content: value.content
            }));
        } else {
            if (field == 'assign_to' && value == 60) {
                setFormData((prev) => ({
                    ...prev,
                    [field]: value,
                    assigned_user_id: userDetails?.user_id ? userDetails?.user_id : '',
                }));
            } else {
                setFormData((prev) => ({
                    ...prev,
                    [field]: value
                }));
            }

        }
    };

    // const [showSettings, setShowSettings] = useState(false);
    const [isSwitchOn, setIsSwitchOn] = useState(false);
    const handleSettingsClick = () => {
        setIsSwitchOn(prev => !prev);
    };

    // upload forward

    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);

    };
    const handleDragOver = (e) => {
        e.preventDefault();
    };
    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];
        let filesProcessed = 0;

        // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
        const existingBase64Files = formData?.base64Files || [];
        const existingFiles = formData?.files || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    const newFiles = filesWithBase64?.map((obj) => obj.file);
                    // const newBase64Files = filesWithBase64.map((obj) => obj.base64);
                    const newBase64Files = filesWithBase64?.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                    const mergedFiles = [...existingFiles, ...newBase64Files];
                    // setFiles(newFiles);
                    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setBase64Files(mergedBase64Files);
                    setFormData((prevFormData) => {
                        // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                        const newFormData = { ...prevFormData, files: mergedFiles, base64Files: mergedBase64Files };

                        return newFormData;
                    });
                }
            };
            reader.readAsDataURL(file);
        });
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const handleImageSelect = (key, data) => {

        if (formData.files) {
            const extension = data?.name?.split('.').pop().toLowerCase();
            if (["jpeg", "jpg", "png", "webp"].includes(extension)) {
                setFormData((prevFormData) => {
                    const updatedFiles = prevFormData.files?.map((file, index) => {
                        if (index === key) {
                            // Toggle the "primary" field for the selected file
                            return {
                                ...file,
                                primary: file.primary === 1 ? 0 : 1,
                            };
                        }
                        return file;
                    });

                    return {
                        ...prevFormData,
                        files: updatedFiles,
                    };
                });

                setSelectedKeys((prevSelected) =>
                    prevSelected.includes(key)
                        ? prevSelected.filter((selectedKey) => selectedKey !== key) // Remove key if already selected
                        : [...prevSelected, key] // Add key if not selected
                );
            }
        }
        if (["jpeg", "jpg", "png", "webp"].includes(data?.file_type)) {

            // setEditFiles((prevFiles) =>
            //     prevFiles.map((file) =>
            //         file.id === data.id
            //             ? { ...file, primary: file.primary === 1 ? 0 : 1 } // Toggle primary between 1 and 0
            //             : file // Leave other files unchanged
            //     )
            // );
        }

    };
    const handleDeleteFile = (index, id, type) => {
        // if (isTopDel) {
        //     setEditFiles((prevFiles) => {
        //         const newFiles = [...prevFiles];
        //         newFiles.splice(index, 1);
        //         return newFiles;
        //     });
        // } else {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        // base64Files.splice(index, 1);
        setBase64Files((prevBase64Files) => {
            const newBase64Files = [...prevBase64Files];
            newBase64Files.splice(index, 1);

            // Update local storage
            setFormData((prevFormData) => {
                const newFormData = { ...prevFormData, base64Files: newBase64Files };
                return newFormData;
            });

            return newBase64Files;
        });
        // }

    };


    const formatOptionLabel = ({ label, imageUrl }, { context }) => {
        const truncateLabel = (label) => {
            if (label.length <= 3) return label;
            return label.slice(0, 3) + '...';
        };

        const displayLabel = context === 'value' ? truncateLabel(label) : label;

        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <img
                    src={imageUrl}
                    alt={label}
                    style={{
                        width: 30,
                        height: 30,
                        objectFit: 'cover',
                        borderRadius: 4,
                        marginRight: 10
                    }}
                />
                <span>{displayLabel}</span>
            </div>
        );
    };

    const defineTask = async () => {
        // console.log("paylaod==>", formData);
        // return false
        let payload = {};
        if (OData) {
            payload = { ...formData, taskable_type: 'service_recovery', ...OData }
        } else {
            payload = formData
        }
        setDisLoading(true);
        try {
            const res = await withRFSToken.post("task/add-update", payload);
            if (res.data.response_code == 200) {
                toast.success(res.data.response_msg);
                onReload(true)
                // window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                CloseModal()

            } else {

                toast.error(res.data.response_msg);
            }
            setDisLoading(false);
        } catch (error) {
            console.error('Error sending request:', error);
            setDisLoading(false);
        }
    };

    return (
        <>
            {console.log('formData', formData)}
            {/* {console.log('awbList', awbList)} */}
            <Modal show={taskModal} onHide={CloseModal} className='add_task_modal' centered size="xl">
                <Modal.Header closeButton >
                    <h6><img src={Modal_user} alt='' className='me-2' />Define and assign a new task</h6>
                </Modal.Header>
                <Modal.Body>
                    {disLoading &&
                        <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
                    }
                    <Form className='add_taskForm'>
                        <Row>
                            <Col md='6'>
                                <Form.Group controlId="validationCustom02" className='mt-1'>
                                    <Form.Label className='mb-1'>Title</Form.Label>
                                    <Form.Control
                                        required
                                        type="text"
                                        placeholder="Title"
                                        value={formData.title}
                                        onChange={(e) => handleFieldChange('title', e.target.value)}
                                    />
                                </Form.Group>
                                <Form.Group controlId="validationCustom01" className='mt-1'>
                                    <Form.Label className='mb-1'>Use template</Form.Label>
                                    <Select
                                        options={templateData}
                                        onChange={selected => handleFieldChange('template_id', selected)}
                                        placeholder="Select a template"
                                        name="template_id"
                                        value={templateData?.find(option => option.value === formData.template_id) || null}
                                    />
                                    {/* <Form.Select
                                required
                                value={formData.template_id}
                                onChange={(e) => {
                                    // const selectedId = parseInt(e.target.value);
                                    // const selectedTemplate = templateData.find(item => item.id === selectedId);
                                    handleFieldChange('template_id', e.target);
                                    console.log('e.target', e.target);

                                    // if (selectedTemplate) {
                                    //     handleFieldChange('title', selectedTemplate.template_title);
                                    //     handleFieldChange('content', selectedTemplate.content || '');
                                    // } else {
                                    //     handleFieldChange('title', '');
                                    //     handleFieldChange('content', '');
                                    // }
                                }}
                            >
                                <option value="">Select a template</option>
                                {templateData?.map((item) => (
                                    <option key={item.value} value={item.value}>
                                        {item.label}
                                    </option>
                                ))}
                            </Form.Select> */}
                                </Form.Group>
                                {/* <Form.Group controlId="validationCustom02" className='mt-1'>
                                    <Form.Label>Document Ref.</Form.Label>
                                    <Select
                                        options={docList}
                                        value={docList?.find(option => option.value == formData?.documentable_id) || null}
                                        onChange={selected => setFormData({
                                            ...formData,
                                            documentable_id: selected?.value,
                                            // documentable_type: selected?.documentable_type,
                                        })}
                                        placeholder="Select Ref"
                                    />
                                </Form.Group> */}
                                <Form.Group className='mt-3'>
                                    <div className="dropfile " onDrop={handleDrop} onDragOver={handleDragOver}>
                                        <h3>Drag and drop files here</h3>
                                        <button className='btn btn-primary drpbtn' onClick={handleBrowseFiles}>Browse Files</button>
                                        <span>Maximum file size 4 MB</span>
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            style={{ display: 'none' }}
                                            onChange={handleFileChange}
                                            multiple
                                        />
                                    </div>

                                    {files?.map((file, index) => {
                                        const fileName = file.name;
                                        const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                        const extension = fileName?.split(".").pop();
                                        return (
                                            <div key={index} className={`img-thumbnail ${selectedKeys.includes(index) ? 'primaryimg' : ''}`} onClick={() => handleImageSelect(index, file)}>
                                                {["jpeg", "jpg", "png", "webp"].includes(file.name.split(".")[file.name.split(".").length - 1]
                                                ) ? (
                                                    <>
                                                        <img
                                                            src={URL.createObjectURL(file)}
                                                            alt="Preview"
                                                            style={{
                                                                maxWidth: "30px",
                                                                maxHeight: "30px",
                                                                marginRight: "5px",
                                                            }}

                                                        />
                                                        <span>
                                                            {/*file.file_name*/}
                                                            {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`}
                                                        </span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <span className="d-flex align-items-center">
                                                            <img src={Docmnt} style={{
                                                                maxWidth: "30px",
                                                                maxHeight: "30px",
                                                                marginRight: "5px",
                                                            }} />
                                                            <span>{file.name}</span>
                                                        </span>
                                                    </>
                                                )}


                                                <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                            </div>
                                        )
                                    })}
                                </Form.Group>
                            </Col>
                            <Col md='6'>
                                <h6 className='mb-0 ps-1 px-0'>Assignment and notifications</h6>
                                <Row>
                                    <Col md={12}>

                                        <Form.Group as={Row} className="mb-0" controlId="formPlaintextAssign to">
                                            <Form.Label column sm="3">Assign to</Form.Label>
                                            <Col sm="9">
                                                <Form.Group>
                                                    {[
                                                        { label: "Myself", value: "60" },
                                                        { label: "A person", value: "61" },
                                                        { label: "Department", value: "62" }
                                                    ].map((opt, idx) => (
                                                        <Form.Check
                                                            key={opt.value}
                                                            inline
                                                            label={opt.label}
                                                            name="group1"
                                                            type="radio"
                                                            id={`inline-radio-${idx}`}
                                                            value={opt.value}
                                                            checked={formData.assign_to === opt.value}
                                                            onChange={(e) => handleFieldChange("assign_to", e.target.value)}
                                                        />
                                                    ))}
                                                </Form.Group>
                                            </Col>
                                        </Form.Group>
                                        {(formData.assign_to === '62') && ( // formData.assign_to === '61' || 
                                            <Form.Group as={Row} className="mb-3" controlId="formPlaintextDepartment">
                                                <Form.Label column sm="3">Department</Form.Label>
                                                <Col sm="9">
                                                    <Select
                                                        options={departmentList}
                                                        value={departmentList?.find(option => option.value == formData.department_id) || null}
                                                        onChange={selected => handleFieldChange('department_id', selected ? selected.value : '')}
                                                        placeholder="Select department"
                                                        isClearable
                                                    />
                                                </Col>
                                            </Form.Group>
                                        )}
                                        {formData.assign_to === '60' &&
                                            <Form.Group as={Row} className="mb-2" controlId="formPlaintextAssignedUser">
                                                <Form.Label column sm="3">Assigned user</Form.Label>
                                                <Col sm="9">
                                                    <Select
                                                        options={userList}
                                                        onChange={selected => setFormData({ ...formData, assigned_user_id: selected ? selected.value : '' })}
                                                        placeholder="Select user"
                                                        // disabled={formData.assign_to === '60'}
                                                        className=''
                                                        name="assigned_user_id"
                                                        value={userList?.find(option => option.value == formData.assigned_user_id) || null}
                                                        isClearable
                                                        isDisabled={formData.assign_to == 60 && formData.assigned_user_id == userDetails?.user_id}
                                                    />
                                                </Col>
                                            </Form.Group>
                                        }
                                        {formData.assign_to === '61' && (
                                            <Form.Group as={Row} className="mb-2" controlId="formPlaintextAssignedUser">
                                                <Form.Label column sm="3">Assigned user</Form.Label>
                                                <Col sm="9">

                                                    <Select
                                                        options={userList}
                                                        onChange={selected => setFormData({ ...formData, assigned_user_id: selected ? selected.value : '' })}
                                                        placeholder="Select user"
                                                        disabled={formData.assign_to === '60'}
                                                        className=''
                                                        name="assigned_user_id"
                                                        value={userList?.find(option => option.value === formData.assigned_user_id) || null}
                                                        isClearable
                                                    />
                                                </Col>
                                            </Form.Group>
                                        )}

                                        <Form.Group as={Row} className="mb-2" controlId="formPlaintextOverduenotif.">
                                            <Form.Label column sm="3">Due date</Form.Label>
                                            <Col sm="9">
                                                <Form.Control
                                                    type="date"
                                                    placeholder="Select Date"
                                                    value={formData.due_date}
                                                    onChange={(e) => handleFieldChange('due_date', e.target.value)}
                                                />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-2" controlId="formPlaintextNotifications">
                                            <Form.Label column sm="3">Notifications</Form.Label>
                                            <Col sm="9">
                                                <Form.Select
                                                    aria-label="Default select example"
                                                    value={formData.notifications}
                                                    onChange={(e) => handleFieldChange('notifications', e.target.value)}
                                                >
                                                    <option value="">(Quick setup the Due & Reminder dates)</option>
                                                    {notification.map((opt) => (
                                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                        </Form.Group>
                                        {!OData &&
                                            <Form.Group as={Row} className="mb-2" controlId="formPlaintextNotifications">
                                                <Form.Label column sm="3">Assign Recovery</Form.Label>
                                                <Col sm="9">
                                                    <Select
                                                        options={awbList}
                                                        value={awbList?.find(option => option.value == formData?.taskable_id) || null}
                                                        onChange={selected => setFormData({
                                                            ...formData,
                                                            taskable_id: selected?.value,
                                                            taskable_type: selected?.taskable_type,
                                                        })}
                                                        placeholder="Select AWB"
                                                    />
                                                </Col>
                                            </Form.Group>
                                        }
                                    </Col>
                                    <Col md={12}>
                                        <div className="d-flex justify-content-end">
                                            <div className='task-settings' onClick={handleSettingsClick} style={{ cursor: 'pointer' }}>
                                                {/* <FontAwesomeIcon icon={showSettings ? faTimes : faCog} size="lg" /> */}
                                                <Form.Check
                                                    type="switch"
                                                    id="custom-switch setting_switch"
                                                    label={isSwitchOn ? "Setting Enabled" : "Setting Disabled"}
                                                    checked={isSwitchOn}
                                                    onChange={(e) => setIsSwitchOn(e.target.checked)}

                                                />
                                            </div>
                                        </div>
                                        {isSwitchOn && (
                                            <div>
                                                <Form.Group as={Row} className="mb-1" controlId="formPlaintextOverduenotif.">
                                                    <Form.Label column sm="3">Overdue notif.</Form.Label>
                                                    <Col sm="9">
                                                        <Form.Control
                                                            type="datetime-local"
                                                            placeholder="Overdue notif"
                                                            value={formData.overdue_notif}
                                                            onChange={(e) => handleFieldChange('overdue_notif', e.target.value)}
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} className="mb-1" controlId="formPlaintextOverduenotif.">
                                                    <Form.Label column sm="3">Reminder date</Form.Label>
                                                    <Col sm="9">
                                                        <Form.Control
                                                            type="datetime-local"
                                                            placeholder="Select Date"
                                                            value={formData.reminder_date}
                                                            onChange={(e) => handleFieldChange('reminder_date', e.target.value)}
                                                        />
                                                    </Col>
                                                </Form.Group>
                                            </div>

                                        )}

                                        {/* <Form.Group as={Row} className="mb-0" controlId="formPlaintextUploadDocument">
                                        <Form.Label column >Upload Document</Form.Label>
                                        <Col sm="9">

                                            <Select
                                                isMulti
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                options={imageOptions}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                value={imageOptions.filter(opt => formData.doc_upload?.includes(opt.value))}
                                                onChange={(selectedOptions) => {
                                                    const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                                    handleFieldChange('doc_upload', values);
                                                }}
                                                placeholder="Select files"
                                                formatOptionLabel={formatOptionLabel}
                                            />
                                        </Col>

                                    </Form.Group> */}

                                        {/* <p className="text-center mb-1">or</p> */}



                                    </Col>
                                </Row>
                            </Col>
                            <Col md='12'>
                                {/* <ActivityComments/> */}
                                <div className='edithtml' >

                                    <MessageBox
                                        value={formData.content || ''}
                                        onMessageChange={content => handleFieldChange('content', content)}
                                    />
                                </div>
                            </Col>
                        </Row>

                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-100 mx-auto are_bottom justify-content-center'>
                        <Button variant="secondary" onClick={CloseModal}>
                            Discard
                        </Button>
                        <Button variant="primary" onClick={() => defineTask()}>
                            Save
                        </Button>

                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default NewTask;